module.exports = __webpack_public_path__ + "static/media/poster-logos.52e52cd4.png";